import React, { useState } from 'react'
import { CardBody, Table, Icons } from '@fabricks/ui-components'
import { useKeycloak } from 'react-keycloak'
import { get as _get } from 'lodash'
import { FbTableColumn, FbTablePagination, FbTableRow } from '@fabricks/ui-components/dist/components/Table/Table'
import { Skeleton } from '@material-ui/lab'
import { PickZoneDto, StorageConfigDto } from '../../api/models'
import { usePickZones, useStorageconfigs } from "../../services/dataService";
import {getDynamicRouteGetters as dynamicRoutes} from "../../constants/navigation";
import {useHistory} from "react-router-dom";

interface StorageconfigsTableProps {}

export const StorageconfigsTable: React.FC = (props: StorageconfigsTableProps) => {
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [keycloak] = useKeycloak()
    const { data, error, loading } =  useStorageconfigs(keycloak.token, { page, size: pageSize })
    const history = useHistory()



    const columns: FbTableColumn[] = [
        { id: 'zone', label: 'Zone' },
        { id: 'zoneEffFactor', label: 'Zone efficiency', renderValue: (value: any) => `${value}`},
        { id: 'customerGroups', label: 'Picking groups', renderValue: (value: any) => value.join(', ')},
        { id: 'pickZone', label: 'Pickzone', renderValue: (value: PickZoneDto) => `${value.name ? value.name : "-"}`},
        { id: 'currentPickZone', label: 'Distance pickzone', renderValue: (value: any) => `${value.distance ? value.distance : '-'} cm`},
        { id: 'bestPosition', label: 'Best position'},
        { id: 'isFlowRackZone', label: 'Flow rack', renderValue: (isFlowRack: boolean) => {
                if (isFlowRack) {
                    return (<div className="indicator_check" style={{ color: 'rgb(144, 238, 2)', cursor: 'pointer' }}><Icons.Check /></div>)
                }
                return (<div style={{ cursor: 'pointer' }}><Icons.Remove /></div>)
            }},
        { id: 'effCalcDone', label: 'Efficiency Calculation', renderValue: (isFlowRack: boolean) => {
                if (isFlowRack) {
                    return (<div className="indicator_check" style={{ color: 'rgb(144, 238, 2)', cursor: 'pointer' }}><Icons.Check /></div>)
                }
                return (<div className="indicator_error" style={{ color: '#d32f2f', cursor: 'pointer' }}><Icons.NotInterested /></div>)
            }},
    ]
    const pagination: FbTablePagination = {
        rowsPerPage: _get(data, 'getStorageConfigs.meta.size', pageSize),
        currentPage: _get(data, 'getStorageConfigs.meta.offset', page),
        count: _get(data, 'getStorageConfigs.meta.count', 0),
        onChangeRowsPerPage: event => setPageSize(parseInt(event.target.value, 10)),
        onChangePage: (event, newPage) => setPage(newPage),
    }
    const rows: FbTableRow[] = _get(data, 'getStorageConfigs.data', []).map((storageConfig: StorageConfigDto) => {
        console.log(storageConfig)
        return { uuid: storageConfig.uuid,
            zone: storageConfig.zone,
            zoneEffFactor: storageConfig.zoneEffFactor || 1.0,
            pickZone: storageConfig.currentPickZone,
            isFlowRackZone: storageConfig.isFlowRackZone,
            bestPosition: storageConfig.bestPosition,
            currentPickZone: storageConfig.currentPickZone,
            estimatedPickZone: storageConfig.estimatedPickZone,
            customerGroups: storageConfig.customerGroups,
            effCalcDone: storageConfig.effCalcDone,
        }
    })

    if (loading) {
        return (
            <>
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{marginBottom: '5px'}} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{marginBottom: '5px'}} />
            </>
        )
    }

    if (_get(data, 'getStorageConfigs.error', null) != null) {
        return (
            <div>
                {_get(data, 'getStorageConfigs.error.message', '')}
                {_get(data, 'getStorageConfigs.error.code', '')}
            </div>
        )
    }

    if (error) {
        return <div>An unknown error has occured</div>
    }

    return (
        <Table
            columns={columns}
            pagination={pagination}
            rows={rows}
            onRowClick={(uuid: string) => history.push(dynamicRoutes().pages.editStorageconfigs(uuid))}
        />
    )
}

export default StorageconfigsTable
